<script>
export default {
    name: 'ProximityAnimation',
    render(createElement) {
        return createElement(
            this.tag,
            this.$slots.default
        )
    },
    props: {
        tag: {
            type: String,
            required: false,
            default: 'span'
        },
        type: {
            type: String,
            required: true
        },
        typeParams: {
            type: Object,
            required: false
        },
        distance: {
            type: Number,
            required: false,
            default: 100
        },
        enable: {
            type: Boolean,
            default: true
        },
        forceStyleReset: {
            type: Boolean,
            default: true
        },
    },
    data() {
        return {
            proximity: null
        }
    },
    computed: {
        checkProximity() {
            return this.proximity !== null && this.proximity <= this.distance;
        }
    },
    watch: {
        proximity(val) {
            if (this.checkProximity && this.enable) {
                /*
                console.log('------');
                console.log('val : ', val);
                console.log('max : ', this.typeParams.max);
                console.log('test : ', (1+((1-(val / this.distance))/this.typeParams.divideIntervalBy)));
                */
                if(this.type === 'scale'){
                    Object.assign(this.$el.style, {
                        'transform': 'scale('+(1+((1-(val / this.distance))/this.typeParams.divideIntervalBy))+ ')'
                    })
                }
                else if(this.type === 'opacity'){
                    Object.assign(this.$el.style, {
                        'opacity': ((1-(val / this.distance))*this.typeParams.multiplicator)
                    })
                }
                else if(this.type === 'left'){
                    let value = (this.typeParams.default+(this.typeParams.default-((val/this.distance)*this.typeParams.default)));
                    Object.assign(this.$el.style, {
                        'left': (value <= this.typeParams.max ? value : this.typeParams.max)+this.typeParams.unit
                    })
                }
                else if(this.type === 'bottom'){
                    let gap = (this.typeParams.max - this.typeParams.default);
                    let value = (this.typeParams.default+(gap-((val/this.distance)*gap)));
                    Object.assign(this.$el.style, {
                        'bottom': (this.typeParams.isNegative ? '-' : '')+(value <= this.typeParams.max ? value : this.typeParams.max)+this.typeParams.unit,
                        //'transform': 'scale3d(1, '+(1+(0.25-((val/this.distance)/4)))+', 1)'
                    })
                }
            }
            else {
                if(this.forceStyleReset){
                    Object.assign(this.$el.style, {
                        'transform': null,
                        'opacity': null,
                        'left': null,
                        'bottom': null
                    });
                }
            }
        },
        checkProximity(val) {
            this.$el.classList.toggle('proximity', val);
        }
    },
    mounted() {
        this.start()
    },
    beforeDestroy() {
        this.stop()
    },
    methods: {
        calculateDistance(e) {
            let elem = this.$el
            let mouseX = e.pageX
            let mouseY = e.pageY

            this.proximity = Math.floor(
                Math.sqrt(
                    Math.pow(
                        mouseX - (elem.getBoundingClientRect().left + elem.getBoundingClientRect().width / 2), 2
                    ) + Math.pow(
                    mouseY - (elem.getBoundingClientRect().top + elem.getBoundingClientRect().height / 2), 2
                    )
                )
            )
        },
        start() {
            if(!this.$store.state.settings.isMobile)
                document.addEventListener('mousemove', this.calculateDistance)
        },
        stop() {
            if(!this.$store.state.settings.isMobile)
                document.removeEventListener('mousemove', this.calculateDistance)
            this.proximity = null
        }
    },
}
</script>
